export default __webpack_public_path__ + "static/breadcrumbs-size-do-f3a2879c544c742603f9d29b34e83a47e4989723ee06e02414600e427ff45625.png";